import { render } from "./sidePopup.vue?vue&type=template&id=0036fb30&scoped=true&ts=true"
import script from "./sidePopup.vue?vue&type=script&lang=ts"
export * from "./sidePopup.vue?vue&type=script&lang=ts"

import "./sidePopup.vue?vue&type=style&index=0&id=0036fb30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0036fb30"]])

export default __exports__